import React from 'react';
import styled from 'styled-components';
import { handleOpenInLayer } from '@oneaudi/feature-app-utils';
import { FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import { Iframe } from './Iframe';
import { PostFormV2 } from '../../rethink/pdp/components/finance/CTA';
export const FocusLayerV2 = ({ link, postData, iframeForms }) => {
    return (React.createElement(LayerContainer, null,
        link.method === 'GET' && iframeForms && React.createElement(Iframe, { src: link.url }),
        link.method === 'POST' && (React.createElement(React.Fragment, null,
            React.createElement(PostFormV2, { link: link, postData: postData, "data-testid": "postForm" })))));
};
export const openFocusLayerV2 = (link, postData, layerManager, iframeForms) => {
    if (link.method === 'GET' && !iframeForms) {
        handleOpenInLayer(link.url, true, true);
        return;
    }
    layerManager === null || layerManager === void 0 ? void 0 : layerManager.openFocusLayer(() => React.createElement(FocusLayerV2, { link: link, postData: postData, iframeForms: iframeForms || false }), {}, {
        size: FocusLayerSizeV2.A,
        userCloseable: true,
    });
};
const LayerContainer = styled.div `
  .nm-layer-title {
    display: none;
  }
`;
